import React, { Suspense } from 'react';
import {Route, Navigate, useNavigate, Routes} from 'react-router-dom';
import {SiteLayout} from 'src/layouts';
import SignIn from 'src/pages/auth/signin';
import cookie from 'js-cookie';
import 'src/styles/App.scss';
import { AllRoutes } from './routes';
// import '@kenshooui/react-multi-select/dist/style.css';

function App() {
  /**
   * Similar to componentDidMount and componentDidUpdate:
   * Checking for the user token availability and changing the isAuthenticated flag value.
   */
  const navigate = useNavigate();
  React.useEffect(() => {
    if (!cookie.get('accessToken') && !cookie.get('username')) {
      navigate('/auth/signin');
    }
  });
  // Rending Routes
  return (
      <Suspense fallback={<></>}>
        <div style={{paddingLeft: '5px', paddingRight: '5px'}}>
          <div className="app-container">
            <Routes>
            <Route
                key={"/auth/signin"}
                path={"/auth/signin"}
                element={
                  cookie.get('accessToken') ? (
                    <SiteLayout>
                      <Navigate to={"/"} />
                    </SiteLayout>
                  ) : (
                    <SiteLayout>
                      <SignIn />
                    </SiteLayout>
                  )
                }
              />
              {AllRoutes && AllRoutes.map((Tab) => {
                const RenderingComponent = Tab["Component"];
                return(
                  <Route
                  key={Tab["name"]}
                  path={Tab["path"]}
                  element={
                    cookie.get('accessToken') ? (
                      <SiteLayout>
                        <RenderingComponent />
                      </SiteLayout>
                    ) : (
                      <SiteLayout>
                        <Navigate to={"/auth/signin"} />
                      </SiteLayout>
                    )
                  }
                  />
                )
              })}

              {/* <PrivateRoute
                path="/company/:company_id/timeseriesdata"
                exact
                component={TimeseriesData}
              /> */}
              
              
              {/* <PrivateRoute
                path="/company/:company_id/timeseriespdf"
                exact
                component={Timeseriespdf}
              />
              <PrivateRoute
                path="/company/:company_id/normaliseddata/:document_id"
                exact
                component={NormalisedData}
              />
              <PrivateRoute
                path="/company/:company_id/normalisedpdf/:document_id"
                exact
                component={NormaliedPdf}
              /> */}
            </Routes>
          </div>
        </div>
      </Suspense>
  );
}

export default App;
